import { Component, OnInit, Input } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { AlertPromise } from 'selenium-webdriver';

@Component({
  selector: 'app-care-channels-footer',
  templateUrl: './care-channels-footer.component.html',
  styleUrls: ['./care-channels-footer.component.scss']
})
export class CareChannelsFooterComponent implements OnInit {
  @Input() titleParam:string;

  constructor(public LANG:CommonUtilitiesService) { }

  ngOnInit() {
  }

}
